import type { Class } from "@/types";
import { CHARACTER_CLASSES } from "@/constants";

export const scout: Class = {
  name: "Scout",
  id: CHARACTER_CLASSES.SCOUT,
  classType: CHARACTER_CLASSES.THIEF,
  description:
    "Scouts are a subclass of Thief who have been toughened by self-sufficiency and isolation from the supplies and comforts of civilized lands. They have the same attack bonus and saving throws as Thieves but use a d6 for hit dice and advance at the same rate as Clerics.",
  hitDie: "1d6",
  primaryAttribute: "dexterity",
  abilityRequirements: [
    {
      ability: "dexterity",
      min: 9,
    },
  ],
  allowedWeapons: [],
  allowedArmor: [],
  specialAbilities: [
    {
      name: "Move Silently",
      description: "Scouts can Move Silently, with percentages based on level.",
    },
    {
      name: "Hide",
      description: "Scouts can Hide, with percentages based on level.",
    },
    {
      name: "Listen",
      description:
        "Scouts can Listen for sounds, with percentages based on level.",
    },
    {
      name: "Open Locks",
      description: "Scouts can Open Locks, with percentages based on level.",
    },
    {
      name: "Detect Traps",
      description: "Scouts can Detect Traps, with percentages based on level.",
    },
    {
      name: "Climb Walls",
      description: "Scouts can Climb Walls, with percentages based on level.",
    },
    {
      name: "Track",
      description:
        "Scouts can track creatures. When tracking, the Scout must roll once per hour traveled or lose the trail.",
    },
  ],
  experienceTable: {
    1: 0,
    2: 1500,
    3: 3000,
    4: 6000,
    5: 12000,
    6: 24000,
    7: 48000,
    8: 90000,
    9: 180000,
    10: 270000,
    11: 360000,
    12: 450000,
    13: 540000,
    14: 630000,
    15: 720000,
    16: 810000,
    17: 900000,
    18: 990000,
    19: 1080000,
    20: 1170000,
  },
  skills: {
    1: {
      openLocks: 10,
      detectTraps: 10,
      moveSilently: 25,
      climbWalls: 50,
      hide: 10,
      listen: 30,
      tracking: 40,
    },
    2: {
      openLocks: 15,
      detectTraps: 15,
      moveSilently: 30,
      climbWalls: 52,
      hide: 15,
      listen: 34,
      tracking: 44,
    },
    3: {
      openLocks: 20,
      detectTraps: 20,
      moveSilently: 35,
      climbWalls: 54,
      hide: 20,
      listen: 38,
      tracking: 48,
    },
    4: {
      openLocks: 25,
      detectTraps: 25,
      moveSilently: 40,
      climbWalls: 56,
      hide: 25,
      listen: 42,
      tracking: 52,
    },
    5: {
      openLocks: 30,
      detectTraps: 30,
      moveSilently: 45,
      climbWalls: 58,
      hide: 30,
      listen: 46,
      tracking: 56,
    },
    6: {
      openLocks: 35,
      detectTraps: 35,
      moveSilently: 50,
      climbWalls: 60,
      hide: 35,
      listen: 50,
      tracking: 60,
    },
    7: {
      openLocks: 40,
      detectTraps: 40,
      moveSilently: 55,
      climbWalls: 62,
      hide: 40,
      listen: 54,
      tracking: 64,
    },
    8: {
      openLocks: 45,
      detectTraps: 45,
      moveSilently: 60,
      climbWalls: 64,
      hide: 45,
      listen: 58,
      tracking: 68,
    },
    9: {
      openLocks: 50,
      detectTraps: 50,
      moveSilently: 65,
      climbWalls: 66,
      hide: 50,
      listen: 62,
      tracking: 72,
    },
    10: {
      openLocks: 53,
      detectTraps: 53,
      moveSilently: 68,
      climbWalls: 68,
      hide: 53,
      listen: 65,
      tracking: 75,
    },
    11: {
      openLocks: 56,
      detectTraps: 56,
      moveSilently: 71,
      climbWalls: 70,
      hide: 56,
      listen: 68,
      tracking: 78,
    },
    12: {
      openLocks: 59,
      detectTraps: 59,
      moveSilently: 74,
      climbWalls: 72,
      hide: 59,
      listen: 71,
      tracking: 81,
    },
    13: {
      openLocks: 62,
      detectTraps: 62,
      moveSilently: 77,
      climbWalls: 74,
      hide: 62,
      listen: 74,
      tracking: 84,
    },
    14: {
      openLocks: 65,
      detectTraps: 65,
      moveSilently: 80,
      climbWalls: 76,
      hide: 65,
      listen: 77,
      tracking: 87,
    },
    15: {
      openLocks: 68,
      detectTraps: 68,
      moveSilently: 83,
      climbWalls: 78,
      hide: 68,
      listen: 80,
      tracking: 90,
    },
    16: {
      openLocks: 69,
      detectTraps: 69,
      moveSilently: 85,
      climbWalls: 79,
      hide: 69,
      listen: 83,
      tracking: 91,
    },
    17: {
      openLocks: 70,
      detectTraps: 70,
      moveSilently: 87,
      climbWalls: 80,
      hide: 70,
      listen: 86,
      tracking: 92,
    },
    18: {
      openLocks: 71,
      detectTraps: 71,
      moveSilently: 89,
      climbWalls: 81,
      hide: 71,
      listen: 89,
      tracking: 93,
    },
    19: {
      openLocks: 72,
      detectTraps: 72,
      moveSilently: 91,
      climbWalls: 82,
      hide: 72,
      listen: 92,
      tracking: 94,
    },
    20: {
      openLocks: 73,
      detectTraps: 73,
      moveSilently: 93,
      climbWalls: 83,
      hide: 73,
      listen: 95,
      tracking: 95,
    },
  },
  supplementalContent: true,
};
